import { Link } from '@tanstack/react-router';

import { t } from '@/shared/i18n';

import styles from './Brand.module.scss';

/**
 * Знак Faceta: буква на акцентном квадрате и название — как во flow-do.
 *
 * Логотипа пока нет — знак собран из типографики, чтобы не ждать его.
 * Ведёт на все сайты: это и есть «дом» админки.
 */
export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/sites" className={styles['brand']} aria-label={t.app.name}>
      <span className={styles['brand__mark']} aria-hidden="true">
        F
      </span>
      {!compact && <span className={styles['brand__name']}>{t.app.name}</span>}
    </Link>
  );
}
